import { ConfigProvider, theme, ThemeConfig } from 'antd';
import clsx from 'clsx';
import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { getOnboarding } from '@/services/Onboarding';
import { IOnboarding } from '@/utils/interfaces/Onboarding';

import { user } from '../../atoms/user';
import OnboardingCompQuestions from '../../components/OnboardingComp';
import { pageTitle } from '../../components/shared/basic/customHead';
import { ShouldRender } from '../../components/shared/basic/ShouldRender';
import { formateErrorObject } from '../../components/shared/formateErrorObject';
import CustomLoader from '../../components/shared/Loading';
import { notify } from '../../components/shared/notify';
import { getUserPersonalityAPI } from '../../services/personalityTest';
import { User } from '../../utils/interfaces/User';
import { ZebraLearnLogo } from '../../../assets';

const config: ThemeConfig = {
  token: { colorPrimary: '#FFFFFF', fontFamily: 'inherit' },
};

const OnboardingPage = () => {
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState<string[]>();
  const router = useRouter();
  const [onboarding, setOnboarding] = useState<IOnboarding>();
  const [onboardingCurrentStep, setOnboardingCurrentStep] = useState<number>(0);

  const userData: User | undefined = useRecoilValue(user);
  const handleResult = async () => {
    try {
      setLoading(true);
      const result = await getUserPersonalityAPI();
      setResults(result?.data);
    } catch (error: any) {
      notify(formateErrorObject(error), 'error');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleResult();
  }, []);

  const getOnboardingHandle = async () => {
    try {
      const result = await getOnboarding();
      setOnboarding(result.data);
    } catch (error: any) {
      notify(formateErrorObject(error), 'error');
    }
  };

  useEffect(() => {
    getOnboardingHandle();
  }, []);

  return (
    <div>
      <Head>
        <title>{pageTitle('Reader Personality Test')}</title>
      </Head>
      {loading ? (
        <CustomLoader />
      ) : (
        <>
          <ShouldRender
            check={userData && results?.length && results?.length >= 4}
          >
            <ConfigProvider
              theme={{ ...config, algorithm: [theme.darkAlgorithm] }}
            >
              <nav
                className={clsx(
                  'flex py-2 fixed z-50 px-3 md:px-5 lg:px-12 border-b-2 border-borderDarkGray items-center justify-between w-full h-14 lg:min-h-16 top-0 bg-bgColor bg-opacity-75 backdrop-filter backdrop-blur-md',
                )}
              >
                <div className='flex  w-full  justify-start items-center cursor-pointer'>
                  <span onClick={() => router.push('/')}>
                    <Image
                      src={ZebraLearnLogo}
                      alt='Logo'
                      priority
                      className='object-contain w-[125px] h-[14px]'
                    />
                  </span>
                </div>
              </nav>
            </ConfigProvider>
          </ShouldRender>
          {onboarding ? (
            <OnboardingCompQuestions
              onboardingCurrentStep={onboardingCurrentStep}
              setOnboardingCurrentStep={setOnboardingCurrentStep}
              onboarding={onboarding}
            />
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};

export default OnboardingPage;
